document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  var STORAGE_KEY = 'kactus_newsletter_popup_dismissed_until';
  var SUBSCRIBED_KEY = 'kactus_newsletter_popup_subscribed';

  if (popup.dataset.enabled === 'false') return;

  var isSuccess = !!popup.querySelector('[data-newsletter-success]');

  // Déjà inscrit → ne plus jamais montrer (sauf juste après l'inscription, pour afficher le merci)
  if (!isSuccess && localStorage.getItem(SUBSCRIBED_KEY) === '1') return;

  // Fermé récemment → respecter le délai de réaffichage (sauf juste après l'inscription)
  var dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
  if (!isSuccess && dismissedUntil && Date.now() < dismissedUntil) return;

  var delaySeconds  = parseInt(popup.dataset.delay, 10) || 0;
  var reappearDays  = parseInt(popup.dataset.reappearDays, 10);

  function openPopup() {
    popup.classList.add('is-visible');
    var input = popup.querySelector('input[type="email"]');
    if (input) input.focus();
  }

  function closePopup(remember) {
    popup.classList.remove('is-visible');
    if (remember) {
      if (reappearDays > 0) {
        var until = Date.now() + reappearDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(STORAGE_KEY, String(until));
      } else {
        // 0 = ne plus jamais réafficher
        localStorage.setItem(STORAGE_KEY, String(Date.now() + 100 * 365 * 24 * 60 * 60 * 1000));
      }
    }
  }

  popup.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
    el.addEventListener('click', function () { closePopup(true); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup(true);
    }
  });

  // Inscription réussie (rendu côté serveur après submit) → ne plus jamais montrer
  if (isSuccess) {
    localStorage.setItem(SUBSCRIBED_KEY, '1');
    openPopup();
  } else {
    setTimeout(openPopup, delaySeconds * 1000);
  }

  // Si le formulaire est soumis avec succès, Shopify recharge la page —
  // on marque l'inscription juste avant le rechargement pour éviter tout flash du popup vide
  var form = popup.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
    });
  }
});